const knIN= {
    login: {
      title: 'ಸೈನ್ ಇನ್',
      sign_in_btn: 'ಸೈನ್ ಇನ್'
    },
    bar: {
        logout: 'ಲಾಗ್ ಔಟ್',
        languages: 'ಭಾಷೆಗಳು',
        settings: 'ಸೆಟ್ಟಿಂಗ್​ಗಳನ್ನು ತೆರೆಯಿರಿ'
    },
    language: {
      name: 'ಇಂಗ್ಲಿಷ್ (US)',
    },
    attributePage: {
        title: 'ಗುಣಲಕ್ಷಣಗಳ ಬದಲಾವಣೆಗಳು',
        viewChanges: 'ಬದಲಾವಣೆಗಳನ್ನು ನೋಡಿ',
        dateTime: 'ದಿನಾಂಕ',
        notificationType: 'ಅಧಿಸೂಚನೆಯ ವಿಧ',
        notificationValue: 'ಅಧಿಸೂಚನೆ ಮೌಲ್ಯ',
        oldValue: 'ಹಳೆಯ ಮೌಲ್ಯ',
        newValue: 'ಹೊಸ ಮೌಲ್ಯ',
        accept: 'ಸ್ವೀಕರಿಸಿ',
        reject: 'ತಿರಸ್ಕರಿಸಿ',
    },
    Home: 'ಮುಖಪುಟ',
    load: 'ಆರಂಭಿಕ ಲೋಡ್ ಅನ್ನು ನಿರ್ವಹಿಸಲಾಗುತ್ತಿದೆ...',
    Requested: "ವಿನಂತಿಸಲಾಗಿದೆ",
    Viewed: "ವೀಕ್ಷಿಸಲಾಗಿದೆ",
    Executing: "ಕಾರ್ಯಗತಗೊಳಿಸಲಾಗುತ್ತಿದೆ",
    Completed: "ಪೂರ್ಣಗೊಂಡಿದೆ",
    Expired: "ಅವಧಿ ಮುಗಿದಿದೆ",
    Cancelled: "ರದ್ದುಗೊಳಿಸಲಾಗಿದೆ",
    Error: "ದೋಷ",
    Rejected: "ತಿರಸ್ಕರಿಸಲಾಗಿದೆ",
    error: 'ಏನೋ ತಪ್ಪಾಗಿದೆ; ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೊಮ್ಮೆ ಪ್ರಯತ್ನಿಸಿ.',
    displayname: 'ಪ್ರದರ್ಶನದ ಹೆಸರು',
    givenname: 'ಹೆಸರು',
    surname: 'ಉಪನಾಮ',
    email: 'ಇಮೇಲ್',
    mail: 'ಇಮೇಲ್',
    name: 'ಹೆಸರು',
    firstname: 'ಹೆಸರು',
    lastname: 'ಉಪನಾಮ',
    footer_copyright: 'ಎಲ್ಲ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ.'
  };
  
  export default knIN;
  